import { createAction, props } from '@ngrx/store';

import { VerificationProfileStatusResponse } from '../../models/verification-profile-response';
import { SummaryState } from '../reducers/summary';

export const GetSummary = createAction('[Verification] Get summary');
export const GetSummarySuccess = createAction(
  '[Verification] Get summary success',
  props<VerificationProfileStatusResponse>(),
);
export const GetSummaryFail = createAction('[Verification] Get summary fail');
export const ExpireBanner = createAction('[Verification] Expire banner');
export const MergeStatus = createAction(
  '[Verification] Merge status',
  props<Partial<Pick<SummaryState, 'idStatus' | 'basicStatus'>>>(),
);
